import template from 'text!./policy-pending-cancel-table_MSF.html';
import JobUtil from 'edge/gateway/util/JobUtil';

export default [function () {
    return {
        restrict: 'EA',
        template: template,
        scope: {
            accounts: '=',
            noResultsMessage: '@'
        },
        controller: ['$scope', function ($scope) {
            $scope.jobUtil = JobUtil;
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/PolicyPendingCancelTableDirective_MSF/PolicyPendingCancelTable_MSF.js
// module id = 1756
// module chunks = 0